import React from "react";
import { Container, Row } from "react-bootstrap";
import { PrismicRichText } from "@prismicio/react";
import Anchor from "../elements/Anchor";
import rhombusFilled from "../../../static/images/general/rhombus-fill.svg";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "../../styles/components/slices/terminology.scss";

const Terminology = ({ slice }) => {
  if (!slice) return null;
  const data = slice.primary;

  return (
    <Container
      fluid
      className="terminology"
      style={
        slice.primary.background_image.gatsbyImageData
          ? {
              backgroundImage: `url(${slice.primary.background_image.gatsbyImageData.images.fallback.src})`,
              backgroundSize: "cover",
            }
          : {}
      }
    >
      <Container className="max-container py-5">
        <Row>
          <h2 className="title text-center mb-4">
            {slice.primary.title1.text}
          </h2>
        </Row>
        <Row className="mx-2 mx-md-5 check-icons">
          <PrismicRichText field={slice.primary.description.richText} />
        </Row>
        <Row>
          {slice.primary.button_label !== null && (
            <div className="book-now-outline my-4 mx-auto d-none d-lg-block w-auto mona">
              <Anchor
                href={slice.primary.button_link.url}
                className="book-now-btn text-center"
              >
                {slice.primary.button_label}
              </Anchor>
            </div>
          )}
        </Row>
      </Container>
    </Container>
  );
};

export default Terminology;
